import { type ILeadStatusConfiguration, type LeadStatus } from '@inpart-io/padme-iap';
import { type GetterTree } from 'vuex';

import { type ILeadStatusConfigurationState } from './types';

export const GET_FROM_STATUS = 'getFromStatus';

export const getters: GetterTree<ILeadStatusConfigurationState, unknown> = {
    [GET_FROM_STATUS]: (_state: ILeadStatusConfigurationState) => {
        return (status: LeadStatus): ILeadStatusConfiguration | undefined => {
            const statusConfigId = _state.byStatus.get(status);
            return _state.dataObjectList.get(statusConfigId);
        };
    }
};
